import React from "react";
import { Link as NextI18nLink } from "@rmh/i18n";

type NextI18nLinkProps = React.ComponentProps<typeof NextI18nLink>;

export function Link({ href, children, ...props }: NextI18nLinkProps) {
  return (
    <NextI18nLink href={href} prefetch={false} {...props}>
      {children}
    </NextI18nLink>
  );
}
